import { combineReducers } from '@reduxjs/toolkit'
import { createBrowserHistory } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'

import addTelegram from './pages/AddTelegram/reducer'
import analytics from './pages/Analytics/reducer'
import balanceReducer from './pages/Balance/reducer'
import budgetRootReducer from './pages/Budget/reducer'
import invoicesReducer from './pages/Invoices/reducer'
import { accountingReducer } from './store/accounting'
import { adAccountsReducer } from './store/adaccounts'
import { antibanReducer } from './store/antiban'
import { appReducer } from './store/app'
import { audiencesReducer } from './store/audiences'
import { budgetReducer } from './store/budget'
import closeDocumentsReducer from './store/documents/documentsSlice'
import { facebookPartnerReducer } from './store/facebook-partner'
import { financialTermsReducer } from './store/financial-terms/financialTermsSlice'
import { myCashbackReducer } from './store/my-cashback'
import { notificationsReducer } from './store/notifications'
import { onboardingReducer } from './store/onboarding'
import { promoReducer } from './store/promo'
import { promocodeReducer } from './store/promocodes'
import { referralReducer } from './store/referral'
import { requestsReducer } from './store/requests'
import { rootApi } from './store/root-api'
import { tikTokReducer } from './store/tiktok'
import { transactionReducer } from './store/transactions'
import { userReducer } from './store/user'

const { routerReducer } = createReduxHistoryContext({ history: createBrowserHistory() })

export const rootReducer = combineReducers({
  [rootApi.reducerPath]: rootApi.reducer,
  analytics,
  accounting: accountingReducer,
  adAccounts: adAccountsReducer,
  antiban: antibanReducer,
  addTelegram,
  app: appReducer,
  audiences: audiencesReducer,
  balance: balanceReducer,
  balances: budgetReducer,
  budget: budgetRootReducer,
  invoices: invoicesReducer,
  myCashback: myCashbackReducer,
  notifications: notificationsReducer,
  onboarding: onboardingReducer,
  promo: promoReducer,
  promocode: promocodeReducer,
  referral: referralReducer,
  requests: requestsReducer,
  router: routerReducer,
  transactions: transactionReducer,
  user: userReducer,
  facebookPartner: facebookPartnerReducer,
  tiktok: tikTokReducer,
  closeDocuments: closeDocumentsReducer,
  financialTerms: financialTermsReducer,
})
